import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
      <h1 className="text-6xl font-bold text-gray-800">404</h1>
      <p className="text-lg text-gray-600 mt-2">Oops! Page not found.</p>
      <Link to="/" className="mt-4 px-6 py-2 text-white bg-blue-500 rounded-lg hover:bg-blue-600">
        Go Home
      </Link>
    </div>
  );
}
